import React from 'react';
import PanelMeasure from '@/layout/components/PanelMeasure';
import CollectionPanelFull from '../containers/CollectionPanelFull';
import CollectionPanelNarrow from '../containers/CollectionPanelNarrow';

const CollectionPanel = ({ configuration, onChange }) => ((
  <PanelMeasure
    configuration={configuration}
    component={{ full: CollectionPanelFull, narrow: CollectionPanelNarrow }}
    onChange={onChange}
  />
));

export default CollectionPanel;
